import { useMemo } from 'react'
import { useAppSelector } from '@/store/hooks'
import { articleModerationApi } from './articleModerationApi'
import { useArticleModeration } from './useArticleModeration'
import { useFreshSince } from './lib/useFreshSince'

/** Состояние модерации статьи, полученное ПОСЛЕ монтирования (см. `useFreshCourseModeration`):
 *  кеш прошлого открытия не в счёт, свежий ответ ставит `ArticleModerationPoller`. */
export const useFreshArticleModeration = (id: number): ReturnType<typeof useArticleModeration> => {
  const moderation = useArticleModeration(id)
  const select = useMemo(() => articleModerationApi.endpoints.getArticleModeration.select(id), [id])
  const isFresh = useFreshSince(id, useAppSelector(select))
  return { ...moderation, state: isFresh ? moderation.state : undefined }
}
